import { render, staticRenderFns } from "./BuildingSocietyFilingHistory.vue?vue&type=template&id=7820e0fa&scoped=true&"
import script from "./BuildingSocietyFilingHistory.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyFilingHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyFilingHistory.vue?vue&type=style&index=0&id=7820e0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820e0fa",
  null
  
)

export default component.exports